import { Icon, IconProps } from "@/base/components/icon/Icon.component";
import IconSvg from "./step-dot.svg?react";

export const StepDotIcon = (props: IconProps) => (
  <Icon component={IconSvg} {...props} />
);
